module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-6877d63e5242949f8ec68d85d217b0c7.png";